import { withResolvePaths } from "../withResolvePaths";
import { AbsoluteModelPath } from "../../../../Common/ModelPath/ModelPath";
import { withFocusManagement } from "../Services/FocusManagement/withFocusManagement";

import { Icon } from "./Icon";

export interface IconContainerProps {
    bindingPath?: AbsoluteModelPath;
}

export const IconContainer = withResolvePaths(withFocusManagement(Icon));
